/* =============================================
   SHIRTBOX THEME — theme.js
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // --- CART DRAWER ---
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = cartDrawer?.querySelector('.cart-drawer__overlay');
  const cartClose = cartDrawer?.querySelector('.cart-drawer__close');

  function openCart() {
    cartDrawer?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Open cart on cart icon click
  document.querySelectorAll('[data-cart-trigger]').forEach(btn => {
    btn.addEventListener('click', e => { e.preventDefault(); openCart(); });
  });
  cartOverlay?.addEventListener('click', closeCart);
  cartClose?.addEventListener('click', closeCart);

  // --- MOBILE NAV ---
  const mobileNav = document.querySelector('.mobile-nav');
  const menuToggle = document.querySelector('.site-header__menu-toggle');
  const mobileNavClose = document.querySelector('.mobile-nav__close');

  menuToggle?.addEventListener('click', () => {
    mobileNav?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });
  mobileNavClose?.addEventListener('click', () => {
    mobileNav?.classList.remove('is-open');
    document.body.style.overflow = '';
  });

  // --- PRODUCT GALLERY THUMBNAILS ---
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImage = document.querySelector('.product-gallery__main img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (mainImage) {
        mainImage.src = thumb.querySelector('img').src.replace('_80x80', '_800x800');
        mainImage.srcset = '';
      }
    });
  });

  // --- VARIANT BUTTONS ---
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-selector__options');
      group?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  // --- QUANTITY SELECTOR ---
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('.quantity-input');
    selector.querySelector('.qty-minus')?.addEventListener('click', () => {
      const val = parseInt(input.value);
      if (val > 1) input.value = val - 1;
    });
    selector.querySelector('.qty-plus')?.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
    });
  });

  // --- ADD TO CART (AJAX) ---
  const addToCartForm = document.querySelector('[data-product-form]');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = addToCartForm.querySelector('[data-add-to-cart]');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      const formData = new FormData(addToCartForm);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (res.ok) {
          btn.textContent = 'Added!';
          await refreshCartDrawer();
          openCart();
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        } else {
          throw new Error('Could not add to cart');
        }
      } catch (err) {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
      }
    });
  }

  // --- REFRESH CART DRAWER ---
  async function refreshCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      // Update cart count badge
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      // Refresh drawer title
      const drawerTitle = cartDrawer?.querySelector('.cart-drawer__title');
      if (drawerTitle) drawerTitle.textContent = `Your Bag (${cart.item_count})`;
    } catch (e) { /* silent */ }
  }

  // Initialize cart count on load
  refreshCartDrawer();

  // --- ANNOUNCEMENT BAR CAROUSEL ---
  const announcementItems = document.querySelectorAll('.announcement-bar__item');
  if (announcementItems.length > 1) {
    let currentIdx = 0;
    announcementItems.forEach((item, i) => {
      item.style.display = i === 0 ? 'block' : 'none';
    });
    setInterval(() => {
      announcementItems[currentIdx].style.display = 'none';
      currentIdx = (currentIdx + 1) % announcementItems.length;
      announcementItems[currentIdx].style.display = 'block';
    }, 4000);
  }

  // --- STICKY HEADER SHRINK ---
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      header?.classList.add('is-scrolled');
    } else {
      header?.classList.remove('is-scrolled');
    }
  });

});
